import { render, staticRenderFns } from "./detail_bccl.vue?vue&type=template&id=6eba70a4&scoped=true&"
import script from "./detail_bccl.vue?vue&type=script&lang=js&"
export * from "./detail_bccl.vue?vue&type=script&lang=js&"
import style0 from "./detail_bccl.vue?vue&type=style&index=0&id=6eba70a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eba70a4",
  null
  
)

export default component.exports